<template>
    <div class="row" :style="rowStyle">
        <div class="col-12">
            <div class="row">
                <div class="form-inline col-md-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="grey lighten-1" class="tooltip-small">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Select the data fields for your custom audience.</span>
                    </v-tooltip>
                    <i class="fas fa-hdd"></i> <span style="padding-left: 5px;"> Competitors</span>
                </div>

                <div class="form-group col-md-3">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="categories"
                                :items="$store.getters['CreateAudienceStore/getCategoriesAll'](dataSetOrder)"
                                @change="categoriesChanged"
                                label="Category"
                                multiple
                                :rules="[requiredCategories]"
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('categories_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('categories_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getCategoriesSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_categories" placeholder="Search" @input="searchItems(dataSetOrder, 'categories')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'categories')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getCategoriesSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'categories') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->

                <div class="form-group col-md-3">
                    <template>
                        <v-container fluid>
                            <v-select
                                v-model="brands"
                                :items="$store.getters['CreateAudienceStore/getBrandsAll'](dataSetOrder)"
                                label="Brands"
                                multiple
                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('brands_' + dataSetOrder)"
                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('brands_' + dataSetOrder)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip small v-if="index === 0">
                                        <span>{{ item.text.substr(0, 7) }}...</span>
                                    </v-chip>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text text-caption"
                                    >
                                      +{{ $store.getters['CreateAudienceStore/getBrandsSelected'](dataSetOrder).length - 1 }}
                                    </span>
                                </template>

                                <template v-slot:prepend-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-text-field v-model="search_brands" placeholder="Search" @input="searchItems(dataSetOrder, 'brands')"></v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>

                                    <v-list-item
                                        ripple
                                        @click="toggleItems(dataSetOrder, 'brands')"
                                    >
                                        <v-list-item-action>
                                            <v-icon :color="$store.getters['CreateAudienceStore/getBrandsSelected'](dataSetOrder).length > 0 ? 'indigo darken-4' : ''">
                                                {{ showingIcon(dataSetOrder, 'brands') }}
                                            </v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Select all
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </v-container>
                    </template>
                </div><!--form-group-->
            </div>
        </div>
    </div>
</template>

<script>
import analyses from "../../../../mixin/analyses"
export default {
    name: "CompetitorsData",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        //
    }),
    methods: {
        requiredBrands(v) {
            if (v.length < 1) {
                return 'Brands field is required'
            }

            return true
        },
        categoriesChanged() {
            this.$store.dispatch('CreateAudienceStore/fetchBrandsByCategories', {dataSetOrder: this.dataSetOrder, analysisType: this.analysisType})
        }
    },
    computed: {
        get_dataset_index_from_order() {
            return this.dataSetOrder.split("_")[1]
        },
        categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCategoriesSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_CATEGORIES', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_categories: {
            get() {
                return this.$store.getters['CreateAudienceStore/getCategoriesSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_COMPETITORS_CATEGORIES_SEARCH', {
                    dataset: this.get_dataset_index_from_order,
                    value: value
                })
            }
        },
        brands: {
            get() {
                return this.$store.getters['CreateAudienceStore/getBrandsSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_BRANDS', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        search_brands: {
            get() {
                return this.$store.getters['CreateAudienceStore/getBrandsSearchInput'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_BRANDS_SEARCH', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        requiredCategories() {
            if (this.checkCategoriesSelected || this.checkBrandsSelected) {
                return true
            }

            return 'Categories field is required'
        },
        checkCategoriesSelected() {
            if (this.$store.getters['CreateAudienceStore/getCategoriesSelected'](this.dataSetOrder).length > 0) {
                return true
            } else {
                return false
            }
        },
        checkBrandsSelected() {
            if (this.$store.getters['CreateAudienceStore/getBrandsSelected'](this.dataSetOrder).length > 0) {
                return true
            } else {
                return false
            }
        },
    },
    mounted() {
        this.$store.dispatch('CreateAudienceStore/fetchCategories', {
            dataSetOrder: this.dataSetOrder,
            analysisType: this.analysisType
        })
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>